import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { ExperimentManager } from './ExperimentManager';

var useExperiments = function useExperiments() {
  var _useState = useState(false),
      isExperimentsReady = _useState[0],
      setIsExperimentsReady = _useState[1];

  useEffect(function () {
    function waitForInit() {
      return _waitForInit.apply(this, arguments);
    }

    function _waitForInit() {
      _waitForInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return ExperimentManager.init();

              case 2:
                setIsExperimentsReady(true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _waitForInit.apply(this, arguments);
    }

    waitForInit();
  }, []);
  return isExperimentsReady;
};

export default useExperiments;